"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _bem = _interopRequireDefault(require("../../utils/bem"));
require("./select.less");
var _jsxRuntime = require("react/jsx-runtime");
var _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Select = exports["default"] = (0, _bem["default"])(_class = /*#__PURE__*/function (_React$Component) {
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Select, [].concat(args));
    _defineProperty(_this, "onChange", function (evt) {
      var _evt$target = evt.target,
        name = _evt$target.name,
        value = _evt$target.value,
        selectedIndex = _evt$target.selectedIndex;
      var index = selectedIndex - 1;
      if (_this.props.setValue) {
        _this.props.setValue(value);
      } else {
        _this.props.onChange({
          evt: evt,
          name: name,
          value: value,
          index: index
        });
      }
    });
    return _this;
  }
  _inherits(Select, _React$Component);
  return _createClass(Select, [{
    key: "getModifiers",
    value: function getModifiers() {
      return [this.isDisabled() ? 'disabled' : null];
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;
      if (!Array.isArray(options)) {
        options = Object.entries(options).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          return {
            value: key,
            label: value
          };
        });
      }
      return options;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      var disabled = this.props.disabled;
      var options = this.getOptions();
      return disabled || !options.length;
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _omit["default"])(this.props, Object.keys(Select.propTypes));
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, props), {}, {
        className: this.getBlockClass(),
        children: [this.renderPlaceholder(), this.renderIcon(), this.renderNative()]
      }));
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder() {
      var _this$props = this.props,
        _this$props$value = _this$props.value,
        value = _this$props$value === void 0 ? '' : _this$props$value,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? 'Select' : _this$props$placehold;
      var options = this.getOptions();
      var selected = options.find(function (option) {
        return option.value === value;
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: this.getElementClass('placeholder'),
        children: (selected === null || selected === void 0 ? void 0 : selected.label) || placeholder
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon["default"], {
        name: "angle-down"
      });
    }
  }, {
    key: "renderNative",
    value: function renderNative() {
      var _this$props2 = this.props,
        name = _this$props2.name,
        placeholder = _this$props2.placeholder;
      var options = this.getOptions();
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        name: name,
        onChange: this.onChange,
        defaultValue: "",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "",
          disabled: true,
          children: placeholder
        }), options.map(function (option) {
          var value = option.value,
            label = option.label;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: value,
            children: label
          }, value);
        })]
      });
    }
  }]);
}(_react["default"].Component)) || _class;
Select.propTypes = {
  options: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  })), _propTypes["default"].object]),
  onChange: _propTypes["default"].func,
  setValue: _propTypes["default"].func,
  placeholder: _propTypes["default"].string
};